import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { FieldRenderProps, useFormState } from 'react-final-form';

import { FieldProps } from '../Field';
import { FormValues } from '../../../../Checkout/types';
import { Select } from '../Select/Select';
import { findSortedAcceptableRules } from '../../../utils';
import { OptionParameterFragment } from '@websky/graphql';

interface Props {
	label: string;
	error: string;
	fieldState: FieldRenderProps<string, HTMLSelectElement>;
	variant?: 'standard' | 'filled' | 'outlined';
}

const DocumentType: React.FC<FieldProps & Props> = ({
	field,
	className,
	error,
	fieldState,
	onChange,
	passengerId,
	label,
	disabled,
	variant,
	menuProps
}) => {
	const { values: formValues } = useFormState<FormValues>();

	const passengerValues = formValues.passengers[passengerId];
	const selectedNationality = (passengerValues?.nationality as string) || 'other';

	// options factory
	const options = useMemo(() => {
		if (!selectedNationality) {
			return [];
		}

		// Применяем функцию findSortedAcceptableRules для получения отсортованных опций согласно коменту
		// https://youtrack.websky.aero/issue/WEBSKY-3214/Ne-otrabatyvaet-proverka-na-minDate-dlya-lyubogo-dokumenta-so-srokom-dejstviya#focus=Comments-4-47829.0-0
		// первыми идут опции из правил с максимальным количеством совпавших with
		const acceptableRules = findSortedAcceptableRules(passengerValues, field.validations);

		if (!acceptableRules.length) {
			return [];
		}

		return acceptableRules[0].options as OptionParameterFragment[];
	}, [passengerValues, selectedNationality, field.validations]);

	const onChangeHandler = useCallback(
		(_, event) => {
			onChange?.(field.name, event);
		},
		[onChange, field.name]
	);

	return (
		<Select
			value={fieldState.input.value}
			options={options.map(option => ({ key: option.value, value: option.label }))}
			name={field.name}
			label={label}
			className={className}
			onChange={onChangeHandler}
			onBlur={(fieldState as any).input.onBlur}
			error={error}
			translateValue={true}
			disabled={disabled}
			variant={variant}
			menuProps={menuProps}
		/>
	);
};

export default DocumentType;
